var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlias = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m99.188 74.523 4.2734-15.848 18.141 1.8281-16.641-12.262-7.4375-36.07-20.02 3.3281-18.918-8.0898-16.141 33.102-19.891 10.023 20.008 2.0078-0.78125 9.5352-23.527-5.1211 10.098 20.672-21.953 42.961h97.754l-2.7266-27.715 12.172-15.23zm-39.809-13.762c-4.8242-0.44922-8.5-3.6992-8.3984-7.3711l0.93359 0.10156v0.0625c-0.12891 1.4336 1.2812 2.7383 3.1758 2.9062 1.8945 0.16797 3.5078-0.85938 3.6367-2.293l10.238 1.0352c-0.69141 3.5234-4.8359 5.9805-9.5859 5.5586zm26.176 2.3555c-4.7109-0.42188-8.332-3.5312-8.4102-7.0898l0.93359 0.089844v-0.003907c0.375 1.4727 1.625 2.5508 3.1328 2.707 1.5078 0.15234 2.9531-0.65234 3.6133-2.0156l10.238 1.0234c-0.81641 3.3945-4.875 5.7109-9.5078 5.2891z",
    fill: "#00abe6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlias);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alias.f458c03697cc55c0eaa09bb13193de1b.svg";